import { Group, Progress, Text, UnstyledButton } from '@mantine/core';
import { IconUpload } from '@tabler/icons-react';
import { useUploadStore } from '../uploadStore';

export function UploadHeaderIndicator() {
  const drawerMinimized = useUploadStore((s) => s.drawerMinimized);
  const restoreDrawer = useUploadStore((s) => s.restoreDrawer);
  const items = useUploadStore((s) => s.items);

  const activeItems = items.filter(
    (i) => i.status === 'pending' || i.status === 'creating' || i.status === 'uploading' || i.status === 'processing'
  );

  if (!drawerMinimized || activeItems.length === 0) return null;

  // Aggregate progress across all active uploads
  const totalBytes = activeItems.reduce((sum, i) => sum + i.bytesTotal, 0);
  const uploadedBytes = activeItems.reduce((sum, i) => sum + i.bytesUploaded, 0);
  const aggregateProgress = totalBytes > 0 ? Math.round((uploadedBytes / totalBytes) * 100) : 0;

  return (
    <UnstyledButton onClick={restoreDrawer}>
      <Group gap="xs" wrap="nowrap">
        <IconUpload size={16} color="var(--mantine-color-blue-6)" />
        <Text size="xs" c="blue" fw={500} style={{ whiteSpace: 'nowrap' }}>
          Uploading {activeItems.length} file{activeItems.length !== 1 ? 's' : ''}...
        </Text>
        <Progress value={aggregateProgress} size="sm" w={80} color="blue" />
      </Group>
    </UnstyledButton>
  );
}
